import React from 'react';

//Imports
import Logo from './logo';
import RecursiveMenu from './recursive-menu';
//End
const Nav = (props) => {
    return (
        <nav id="sidebar" aria-label="Main Navigation">
            <div className="bg-header-dark">
                <div className="content-header bg-white-10">

                    {props.info.logoOnMenu ? <Logo props={props} /> : null}

                    <div>

                        {
                            props.info.topBarBlackMenuOpt ?
                                <a className="js-class-toggle text-white-75" data-target="#sidebar-style-toggler" data-class="fa-toggle-off fa-toggle-on" data-toggle="layout" data-action="sidebar_style_toggle" href="javascript:void(0)">
                                    <i className="fa fa-toggle-off" id="sidebar-style-toggler"></i>
                                </a>
                                : null
                        }

                        <a className="d-lg-none text-white ml-2" data-toggle="layout" data-action="sidebar_close" href="javascript:void(0)">
                            <i className="fa fa-times-circle"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div className="content-side content-side-full">
                <ul className="nav-main">
                    <RecursiveMenu data={props.menu} />
                </ul>
            </div>
        </nav>
    )
}

export default Nav;